import { useCallback } from "react"
import { useOcupacaoApi } from "../../../infra/geo-veles"
import { useAppDispatch, useAppSelector } from "../../../presentation/hooks/store-hooks"
import { setOcupacaoSearchTermState, setOcupacoesState, setOpenOcupacaoDialogState, resetOcupacaoSearchTermState, resetOcupacoesState, setOcupacaoCategoriaState, resetOcupacaoCategoriaState } from "../../../application/states/geo-veles"
import { IOcupacao } from "../../../application/models"
import { useUIService } from "../../ui"

export const useOcupacaoService = () => {
    // Dispatch
    const dispatch = useAppDispatch()
    // State
    const { ocupacao } = useAppSelector((state) => state)
    // Hook
    const { setAlert } = useUIService()
    // API
    const { getOcupacaoBySearchTermApi } = useOcupacaoApi()

    // Hooks
    const setSearchTerm = useCallback((searchTerm: string) => {
        dispatch(setOcupacaoSearchTermState(searchTerm))
    }, [dispatch])

    const resetSearchTerm = useCallback(() => {
        dispatch(resetOcupacaoSearchTermState())
    }, [dispatch])

    const setCategoria = useCallback((categoria: keyof IOcupacao) => {
        dispatch(setOcupacaoCategoriaState(categoria))
    }, [dispatch])

    const resetCategoria = useCallback(() => {
        dispatch(resetOcupacaoCategoriaState())
    }, [dispatch])

    const searchOcupacoes = useCallback(async () => {
        try {
            const findOcupacao = await getOcupacaoBySearchTermApi({
                searchTerm: ocupacao.searchTerm,
                categoria: ocupacao.categoria
            })

            dispatch(setOcupacoesState(findOcupacao))
        } catch (error: any) {
            setAlert({
                message: error.response.data.error,
                type: 'error'
            })
        }
    }, [getOcupacaoBySearchTermApi, ocupacao.searchTerm, ocupacao.categoria, dispatch, setAlert])

    const resetOcupacoes = useCallback(() => {
        dispatch(resetOcupacoesState())
    }, [dispatch])

    const setOpenOcupacaoDialog = useCallback((openDialog: boolean) => {
        dispatch(setOpenOcupacaoDialogState(openDialog))
    }, [dispatch])

    return {
        setSearchTerm,
        resetSearchTerm,
        setCategoria,
        resetCategoria,
        searchOcupacoes,
        resetOcupacoes,
        setOpenOcupacaoDialog
    }
}